module.exports = __webpack_public_path__ + "img/kuchanskiy.ed36d073.jpg";